/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {NgModule} from '@angular/core';

import {ClrButtonGroupModule} from './button-group/button-group.module';
import {ClrLoadingButtonModule} from './button-loading/loading-button.module';
export class ClrButtonModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    exports: [
        ClrLoadingButtonModule,
        ClrButtonGroupModule,
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrButtonModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
